import {TaskVariable} from "./task-variable.model";

export class Task {
  public state?: TaskStatus;
  public variables?: TaskVariable[];
  public processId?: string;
  public name?: string;
  public description?: string;
  public startedAt?: string;
  public id?: string;
  public assignee?: string;
  public activityDefinitionId?: string;

  constructor(obj?: any) {
    if(obj) {
      this.state = obj.state || null;
      this.variables = obj.variables || null
      this.processId = obj.processId || null;
      this.name = obj.name || null;
      this.description = obj.description || null;
      this.startedAt = obj.startedAt || null;
      this.id = obj.id || null;
      this.assignee = obj.assignee || null;
      this.activityDefinitionId = obj.activityDefinitionId || null;
    }
  }

}

export enum Outcome {
  APPROVE = "Approve",
  REJECT = "Reject",
  SIGN = "Sign"
}

export enum TaskStatus {
  COMPLETED = "completed",
  CLAIMED = "claimed",
  UNCLAIMED = "unclaimed",
  DELEGATED = "delegated",
  RESOLVED = "resolved"
}
